import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider, useSelector } from "react-redux";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createMuiTheme } from "./features/layout/themes/muiTheme";
import store from "./store/store";
import App from "./App";
import "./index.css";
import { selectCurrentTheme } from "./features/layout/layoutSlice";

const Root = () => {
  const theme = useSelector(selectCurrentTheme);
  const muiTheme = createMuiTheme(theme);

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <Root />
    </Provider>
  </StrictMode>
);
